import React, { type FC, type ReactNode } from "react";
import { LeftOutlined } from "@ant-design/icons";
import { usePageTitle } from "../../../CommonComponents/Layout/PageTitleContext";
import styles from "./CampaignBuilderHeader.module.css";

export type CampaignBuilderHeaderProps = {
  title: string;
  backAriaLabel: string;
  onBack: () => void;
  /** Right-side action buttons. Omitted or empty when create has no header CTAs. */
  actions?: ReactNode;
};

/**
 * Shared create/edit header for campaign, series, and template builders.
 * Visual shell only — callers own which actions to render and their handlers.
 */
const CampaignBuilderHeader: FC<CampaignBuilderHeaderProps> = ({
  title,
  backAriaLabel,
  onBack,
  actions,
}) => {
  usePageTitle(title);

  const hasActions = React.Children.toArray(actions).some(Boolean);

  return (
    <div className={styles.header}>
      <button
        type="button"
        className={styles.backButton}
        onClick={onBack}
        aria-label={backAriaLabel}
      >
        <span className={styles.backButtonIcon}>
          <LeftOutlined />
        </span>
      </button>
      {hasActions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
};

export default CampaignBuilderHeader;
